module.exports = __webpack_public_path__ + "img/ekyc.37bd0516.png";